// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.priceRangeStyle_priceRange__gvlkX {
  display: flex;
  align-items: center;
}
.priceRangeStyle_priceRange__gvlkX .priceRangeStyle_input__iqmoE {
  width: 100%;
  padding: 10px 14px;
  border-radius: var(--border-radius);
  background-color: var(--white);
  border: 1px solid var(--border);
  color: var(--primary-Text);
  font: var(--body-font-three);
  font-weight: 500;
}
.priceRangeStyle_priceRange__gvlkX .priceRangeStyle_middleLine__uGqUF {
  width: 16px;
  height: 1px;
  display: inline-block;
  background-color: var(--border);
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/price-range/priceRangeStyle.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;AACD;AACC;EAEC,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,8BAAA;EACA,+BAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;AAAF;AAGC;EACC,WAAA;EACA,WAAA;EACA,qBAAA;EACA,+BAAA;AADF","sourcesContent":[".priceRange {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\r\n\t.input {\r\n\t\t// max-width: 120px;\r\n\t\twidth: 100%;\r\n\t\tpadding: 10px 14px;\r\n\t\tborder-radius: var(--border-radius);\r\n\t\tbackground-color: var(--white);\r\n\t\tborder: 1px solid var(--border);\r\n\t\tcolor: var(--primary-Text);\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 500;\r\n\t}\r\n\r\n\t.middleLine {\r\n\t\twidth: 16px;\r\n\t\theight: 1px;\r\n\t\tdisplay: inline-block;\r\n\t\tbackground-color: var(--border);\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"priceRange": `priceRangeStyle_priceRange__gvlkX`,
	"input": `priceRangeStyle_input__iqmoE`,
	"middleLine": `priceRangeStyle_middleLine__uGqUF`
};
export default ___CSS_LOADER_EXPORT___;
